<template>
    <div>
        <v-container grid-list-xl pt-0>
            <h3 class="">Bảng chấm công</h3>
            <page-tool-bar show_search show_date_start show_date_end :loading="loader" :search.sync="search"
                :date_start.sync="date_start" :date_end.sync="date_end">
                <v-flex xs12 md2>
                    <v-select label="Trạng thái" :disabled="loader" v-model="repair_timesheet_status"
                        :items="[...repair_timesheet_status_options, 'Tất cả']" item-text="name" item-value="name"
                        hide-details></v-select>
                </v-flex>
                <v-flex xs12 md2>
                    <v-select label="Thợ sửa" :disabled="loader" v-model="repairman_name"
                        :items="[...repairmen_name, 'Tất cả']" item-text="name" item-value="name"
                        prepend-icon="person_pin" hide-details></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="download_csv_count++" color="primary" dark>XUẤT EXCEL</v-btn>
                        <dialog-tao-cham-cong @reloadTable="reload_table++"></dialog-tao-cham-cong>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <table-cham-cong :date_start="date_start" :date_end="date_end" :search="search"
                            :repairman_name="repairman_name" :reload_table="reload_table" :loader.sync="loader"
                            :download_csv_count="download_csv_count" :repair_timesheet_status="repair_timesheet_status"></table-cham-cong>
                    </v-card>
                </v-flex>
            </v-layout>

        </v-container>
    </div>
</template>

<script>

import api from "Api"
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'
import { buildParamQuery } from "Helpers"
import moment from 'moment'
import { REPAIR_TIMESHEET_STATUS } from "../../constants/db-config"
import TableChamCong from "./TableChamCong"

export default {
    name: "cham-cong-layout",
    props: ["reloadRepairTimesheetTable"],
    components: {
        TableChamCong,
        ExportCsvButton
    },
    data() {
        return {
            repairmen_name: [],
            reload_table: 0,
            download_csv_count: 0,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substring(0, 10),
            loader: false,
            search: "",
            repairman_name: 'Tất cả',
            repair_timesheet_status: 'Tất cả',
            REPAIR_TIMESHEET_STATUS
        }
    },
    mounted() {
        this.reload_table++;
        this.getRepairmenName()
    },
    computed: {
        repair_timesheet_status_options(){
            return Object.values(this.REPAIR_TIMESHEET_STATUS);
        },
    },
    watch: {
        date_start() {
            this.reload_table++
        },
        date_end() {
            this.reload_table++
        },
        reloadRepairTimesheetTable() {
            this.reload_table++
        },
    },
    methods: {
        async getRepairmenName() {
            const params = {};
            const query = buildParamQuery(params)
            const response = await api.getRepairmen(query);
            if (response.status === 200) {
                this.repairmen_name = response.data.map(item => {
                    return item.name;
                });
            }
        }
    }
}
</script>

<style></style>